/**
 * C15 company Q&A view-model — pure display shaping for the chatbot-qa manager:
 * the free-text filter over the company question bank, the active/inactive status
 * key, the alternate-phrasing count, and the shaping of the POST /chatbot-qa/ask
 * "test-ask" response into a display object (matched? / answer / confidence % /
 * source). Kept out of the .vue so node:test can cover the logic directly (the
 * companies repo has no SFC test runner). The template just binds the output.
 */

function norm(v) {
  return String(v == null ? '' : v).trim().toLowerCase();
}

// Active/inactive key for the .tag class + i18n label. The insurer/company owns
// the isActive flag; only explicit `false` means paused, so anything else is on.
function statusOf(qa) {
  return qa && qa.isActive === false ? 'inactive' : 'active';
}

// Number of alternate phrasings stored on a Q&A (empty-safe).
function phrasingCount(qa) {
  return qa && Array.isArray(qa.phrasings) ? qa.phrasings.length : 0;
}

// Free-text filter across the question, answer, category and every alternate
// phrasing so an HR search matches on any wording. Empty query returns all rows.
function filterQa(rows, q) {
  var list = rows || [];
  var needle = norm(q);
  if (!needle) return list;
  return list.filter(function (r) {
    var hay = [r.question, r.answer, r.category].map(norm);
    var phr = (r.phrasings || []).map(norm);
    hay = hay.concat(phr);
    return hay.some(function (h) {
      return h.indexOf(needle) !== -1;
    });
  });
}

// Clamp a 0..1 confidence to an integer percentage for display.
function confidencePct(n) {
  var c = Number(n);
  if (!isFinite(c) || c < 0) c = 0;
  if (c > 1) c = 1;
  return Math.round(c * 100);
}

// Shape the raw /chatbot-qa/ask envelope into what the chat preview binds. A
// company match only counts when the backend returned a matched id from the
// company bank; otherwise it is a fallback (no approved answer over threshold).
function shapeAsk(result) {
  var r = result || {};
  var matched = !!r.matchedQaId && r.source === 'company';
  return {
    matched: matched,
    matchedQaId: r.matchedQaId || null,
    answer: matched ? r.answer || '' : '',
    source: r.source || 'fallback',
    confidencePct: confidencePct(r.confidence),
  };
}

module.exports = {
  statusOf: statusOf,
  phrasingCount: phrasingCount,
  filterQa: filterQa,
  confidencePct: confidencePct,
  shapeAsk: shapeAsk,
};
